import {toBoolean, toNumber, toString} from "../helpers/helpers";

function parseDateFromJSON(date) {
  if (!date) return "";
  const matches = `${date}`.match(/^([0-9]{4}-[0-9]{2}-[0-9]{2})T?/i) || [];
  return matches[1] || "";
}

export class BulkOrderLineItemModel {
  id: string;
  type: string;
  bulkOrderId: string;
  deviceId: string;
  productNumber: string;
  productDescription: string;
  deviceKey: string;
  catalogPricingEnabled: boolean; // whether catalog pricing enabled

  /**
   * @type {number}
   * Original quantity value (when loaded)
   */
  originalQuantity: number;

  /**
   * @type {number}
   * Number of assets/accessories (to be) ordered for this bulk order
   */
  quantity: number;

  /**
   * @type {number}
   * Total number of assets/accessories on DART deal
   */
  dartQuantity: number;

  /**
   * @type {number}
   * Total number of assets/accessories, from DART, that can still be ordered
   */
  maxQuantity: number;

  /**
   * @type {number}
   * Number of associated assets/accessories
   */
  quantityAssigned: number;

  /**
   * @type {number}
   * Number of slots for associated assets/accessories
   */
  quantityAvailable: number;

  orderNumber: string;
  orderDate: string;
  disabled: boolean;
  isInvalid: boolean;
  quicksilver: boolean;

  constructor(json?: any) {
    this.id = toString(json.id);
    this.type = toString(json.type);
    this.bulkOrderId = toString(json.bulkOrderId);
    this.deviceId = toString(json.deviceId);
    this.productNumber = toString(json.productNumber);
    this.productDescription = toString(json.productDescription);
    this.deviceKey = toString(json.deviceKey);
    this.originalQuantity = toNumber(json.originalQuantity) || toNumber(json.quantity);
    this.quantity = toNumber(json.quantity);
    this.dartQuantity = toNumber(json.dartQuantity);
    this.maxQuantity = toNumber(json.maxQuantity);
    this.catalogPricingEnabled = toBoolean(json.catalogPricingEnabled);
    this.quantityAssigned = toNumber(json.quantityAssigned);
    this.quantityAvailable = toNumber(json.quantityAvailable);
    this.orderNumber = toString(json.orderNumber);
    this.orderDate = parseDateFromJSON(json.orderDate);
    this.disabled = toBoolean(json.disabled);
    this.isInvalid = toBoolean(json.isInvalid);
    this.quicksilver = toBoolean(json.quicksilver);
  }
}
